import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	pageHeading: {
		id: 'portfolio-3-financial-year-dates.ui.page-heading',
		defaultMessage: 'Financial year',
		description: 'The heading for the Plans financial year dates page',
	},
	sectionMessage: {
		id: 'portfolio-3-financial-year-dates.ui.section-message',
		defaultMessage: 'This setting will be applied to all plans in Jira.',
		description: 'The section message on the financial year dates page.',
	},
	monthSelectLabel: {
		id: 'portfolio-3-financial-year-dates.ui.month-select-label',
		defaultMessage: 'Select the start month of the financial year.',
		description: 'The description for the custom fiscal year radio button.',
	},
	successFlagTitle: {
		id: 'portfolio-3-financial-year-dates.ui.success-flag-title',
		defaultMessage: 'Financial year dates saved',
		description: 'The title for the success flag.',
	},
	successFlagDescription: {
		id: 'portfolio-3-financial-year-dates.ui.success-flag-description',
		defaultMessage: 'These financial quarter dates will apply to all plans',
		description: 'The description for the success flag.',
	},
	resetDatesLabel: {
		id: 'portfolio-3-financial-year-dates.ui.reset-dates-label',
		defaultMessage: 'Reset dates',
		description: 'The label for the reset dates button.',
	},
	errorFlagTitle: {
		id: 'portfolio-3-financial-year-dates.ui.error-flag-title',
		defaultMessage: "We couldn't save your financial year dates",
		description: 'The title for the error flag.',
	},
});
